import { useTenantStore } from '../stores/tenant.store';

/**
 * Tenant hook
 * Provides tenant information
 */
export function useTenant() {
  const store = useTenantStore();

  return {
    // State
    tenant: store.tenant,
    isLoaded: store.isLoaded,
    isLoading: store.isLoading,
    error: store.error,

    // Computed values
    tenantId: store.tenant?.id,
    tenantName: store.tenant?.displayName || store.tenant?.name,
    tenantLogo: store.tenant?.logo,
    tenantFavicon: store.tenant?.favicon,
  };
}
